import React from 'react'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import InfoItem from 'features/GamePopup/Components/InfoItem'
import { INFO_ITEMS } from 'configs/gamePopup'
import { PROVIDERS } from 'common/providers'

const ListWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`

const InfoList = (props) => {
    const getTransformedValue = (item, rawValue) => {
        // Handle value replacement via lookup table if defined
        if (item.valueReplace) {
            return item.valueReplace[rawValue] || rawValue
        }

        // Handle special case for subprovider
        if (item.key === 'subprovider') {
            // Map 'gdm' to 'scientific'
            const normalizedValue = rawValue === 'gdm' ? 'scientific' : rawValue

            // Look up provider label if available
            const provider = PROVIDERS.find(
                (provider) => provider.value === normalizedValue
            )
            return (provider && provider.label) || normalizedValue
        }

        return rawValue
    }

    return (
        <ListWrapper>
            {INFO_ITEMS.map((item, index) => {
                const rawValue = props[item.key]
                const displayValue = getTransformedValue(item, rawValue)

                // Skip rendering if value is falsy or zero
                if (!displayValue || displayValue === '0') {
                    return null
                }

                return <InfoItem key={index} value={displayValue} {...item} />
            })}
            <ReactTooltip />
        </ListWrapper>
    )
}

export default InfoList
